import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {
  const { t } = useTranslation();

  const values = [
    {
      icon: 'ri-hand-heart-line',
      title: t('about_value1_title'),
      description: t('about_value1_desc')
    },
    {
      icon: 'ri-time-line',
      title: t('about_value2_title'),
      description: t('about_value2_desc')
    },
    {
      icon: 'ri-shield-user-line',
      title: t('about_value3_title'),
      description: t('about_value3_desc')
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-stone-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-xs uppercase tracking-wider text-amber-500 mb-4">{t('about_hero_label')}</div>
          <h1 className="text-4xl md:text-5xl font-medium mb-6 leading-tight">
            "{t('about_hero_title')}"
          </h1>
          <p className="text-lg text-stone-300 leading-relaxed italic">
            {t('about_hero_subtitle')}
          </p>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-16 lg:py-24">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <img
                  src="https://readdy.ai/api/search-image?query=Ukrainian%20male%20veteran%20founder%20in%20civilian%20clothes%2C%20confident%20professional%20portrait%2C%20natural%20lighting%2C%20authentic%20expression%2C%20leadership%20presence%2C%20outdoor%20setting%2C%20warm%20atmosphere%2C%20genuine%20smile%2C%20approachable%20demeanor&width=300&height=400&seq=about001m&orientation=portrait"
                  alt="Male founder of Valhalla on Earth"
                  className="w-full rounded-lg shadow-sm object-top"
                />
              </div>
              <div>
                <img
                  src="https://readdy.ai/api/search-image?query=Ukrainian%20female%20veteran%20founder%20in%20civilian%20clothes%2C%20strong%20professional%20portrait%2C%20natural%20lighting%2C%20authentic%20expression%2C%20leadership%20presence%2C%20outdoor%20setting%2C%20warm%20atmosphere%2C%20confident%20smile%2C%20approachable%20demeanor&width=300&height=400&seq=about001f&orientation=portrait"
                  alt="Female founder of Valhalla on Earth"
                  className="w-full rounded-lg shadow-sm object-top"
                />
              </div>
            </div>
            <div>
              <h2 className="text-3xl font-medium text-stone-800 mb-6">{t('about_story_title')}</h2>
              <p className="text-stone-600 leading-relaxed mb-6">
                {t('about_story_p1')}
              </p>
              <p className="text-stone-600 leading-relaxed mb-6">
                {t('about_story_p2')}
              </p>
              <p className="text-stone-600 leading-relaxed">
                {t('about_story_p3')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="py-16 bg-stone-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-medium text-stone-800 mb-8">{t('about_mission_title')}</h2>
          <p className="text-xl text-stone-700 leading-relaxed mb-8">
            {t('about_mission_main')}
          </p>
          <p className="text-lg text-stone-600 leading-relaxed">
            {t('about_mission_desc')}
          </p>
        </div>
      </section>

      {/* Values */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-medium text-stone-800 mb-6">{t('about_values_title')}</h2>
            <p className="text-lg text-stone-600 leading-relaxed">
              {t('about_values_desc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center">
                <div className="w-18 h-18 bg-amber-500/10 rounded-lg flex items-center justify-center mx-auto mb-6">
                  <i className={`${value.icon} text-3xl text-amber-600`}></i>
                </div>
                <h3 className="text-xl font-semibold text-stone-800 mb-4">{value.title}</h3>
                <p className="text-stone-600 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What Makes Us Different */}
      <section className="py-16 bg-stone-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-medium text-stone-800 text-center mb-12">{t('about_different_title')}</h2>
          
          <div className="space-y-8">
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-xl font-semibold text-stone-800 mb-3">{t('about_different1_title')}</h3>
              <p className="text-stone-600 leading-relaxed">
                {t('about_different1_desc')}
              </p>
            </div>

            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-xl font-semibold text-stone-800 mb-3">{t('about_different2_title')}</h3>
              <p className="text-stone-600 leading-relaxed">
                {t('about_different2_desc')}
              </p>
            </div>

            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-xl font-semibold text-stone-800 mb-3">{t('about_different3_title')}</h3>
              <p className="text-stone-600 leading-relaxed">
                {t('about_different3_desc')}
              </p>
            </div>

            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-xl font-semibold text-stone-800 mb-3">{t('about_different4_title')}</h3>
              <p className="text-stone-600 leading-relaxed">
                {t('about_different4_desc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Looking Forward */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-medium text-stone-800 mb-6">{t('about_forward_title')}</h2>
            <p className="text-lg text-stone-600 leading-relaxed max-w-2xl mx-auto">
              {t('about_forward_desc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-stone-50 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-stone-800 mb-4">{t('about_expanding_title')}</h3>
              <p className="text-stone-600 leading-relaxed">
                {t('about_expanding_desc')}
              </p>
            </div>

            <div className="bg-stone-50 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-stone-800 mb-4">{t('about_systemic_title')}</h3>
              <p className="text-stone-600 leading-relaxed">
                {t('about_systemic_desc')}
              </p>
            </div>
          </div>

          <div className="text-center mt-12">
            <p className="text-lg text-stone-600 leading-relaxed mb-8">
              {t('about_core_mission')}
            </p>
            <a
              href="/contact"
              className="inline-block bg-stone-800 text-white px-8 py-4 rounded-full font-medium hover:bg-amber-600 transition-colors duration-300 whitespace-nowrap"
            >
              {t('about_cta_button')}
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}